<template>
  <form
    :class="['c-step', 'c-step--one', { 'disable-app': app.disableApp }]"
    v-on:submit.prevent
  >
    <Title
      class="top-head mb-40 hide-mobile"
      :dataTitle="'På udkig efter'"
      :dataStrong="'Ny bilforsikring?'"
    />
    <checklistband :dataItems="checklistData" />
    <div class="d-flex row price_container">
      <p class="dirty-price">{{ dirty ? "Din pris pr. md." : "Fra pris pr. md." }}</p>
      <Price :dataPrice="app.price != -1 ? app.price + ',-' : '---'" />
      <span class="own-risk">{{ ownRisk.title }}</span>
    </div>

    <Button
      v-if="!app.isAM"
      class="showTheRest_button"
      v-on:childToParent="showTheRest = !showTheRest"
      :text="app.priceError || app.disableApp ? 'Kan ikke tilbydes' : 'Beregn din pris'"
      :give-padding="false"
      :disabled="app.priceError || app.disableApp"
      :is-active="true"
    />
    <transition name="showTheRest" mode="out-in">
      <div class="showTheRest_container" v-if="showTheRest">
        <AgeAndVehicleValue
          class="mb-25"
          :validateShow="validateShow"
          v-on:childToParent="AgeAndVehicleValueChange"
        />

        <Button
          v-if="app.isAM"
          :class="[
            'showTheRest_button',
            { 'showTheRest_button--am': app.isAM },
            { 'showTheRest_button--am-active': showTheRest_am },
          ]"
          v-on:childToParent="showTheRest_am = !showTheRest_am"
          :text="'Vis tilvalg'"
          :give-padding="false"
          :disabled="app.priceError || app.disableApp"
          :is-active="true"
        />

        <!-- <pre>
  app.isAm && showTheRest_am  {{ app.isAM && showTheRest_am  }}
  !app.isAm {{ !app.isAM }}
  app.isAm {{ app.isAM }}
</pre> -->

        <CheckboxList
          v-if="(app.isAM && showTheRest_am) || !app.isAM"
          :key="forceUpdateCBL"
          :dataItems="checkboxListData"
          v-on:childToParent="checkboxListChange"
        >
          <template v-slot:CheckboxItemExtraSlot="slotProps">
            <div
              class="carAgeslot"
              v-if="
                slotProps.item.value == 'includeRoadAssistance' && slotProps.item.checked
              "
            >
              <InputText
                class="carAgeInputText"
                :dataText="app.ins.carAge"
                :dataTitle="'Bilens alder*'"
                :dataType="'carAge'"
                :dataInputType="'text'"
                :dataInputPattern="'^[0-9]{1,2}$'"
                :dataInputSize="2"
                :isRequired="true"
                v-on:childToParent="carAgeChange"
                :restrictedToLength="2"
                :restrictedToNumbers="true"
                :validateShow="validateShow"
                :validateText="'Indtast venligst bilens alder'"
              />
              <Infohover
                class="carAgeInfohover"
                :helptitle="'Bilens alder'"
                :helptexthtml="'Her skal indtastes bilens alder i år. Ikke år fra første indregistrering men bilens reelle alder.'"
              ></Infohover>
            </div>
          </template>
        </CheckboxList>

        <div class="d-flex row mt-25" v-if="!app.isAM">
          <Button
            v-on:childToParent="buttonClick"
            :text="
              app.priceError || app.disableApp ? 'Kan ikke tilbydes' : 'Bestil tilbud'
            "
            :give-padding="false"
            :disabled="app.priceError || app.disableApp"
            :is-active="true"
          />
        </div>
      </div>
    </transition>
  </form>
</template>
<script>
import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("app");
import Title from "@/components/title/title.vue";
import Button from "@/components/button/button.vue";
import AgeAndVehicleValue from "@/components/Scenes/Age-Vehicle-Value/age-vehicle-value.vue";
// import Head from '@/components/head/head.vue';
import Price from "@/components/price/price.vue";
import checklistband from "@/components/checklist-band/checklist-band.vue";
import CheckboxList from "@/components/checkbox-list/checkbox-list.vue";
import { staticData } from "@/helper/staticData.js";
import Infohover from "@/components/infohover/info-hover.vue";
import InputText from "@/components/input-text/input-text.vue";

export default Vue.extend({
  name: "Step1",
  components: {
    AgeAndVehicleValue,
    Button,
    Title,
    // Head,
    checklistband,
    CheckboxList,
    Price,
    Infohover,
    InputText,
  },
  data() {
    return {
      dirty: false,
      validateShow: false,
      disableBtn: false,
      forceUpdateCBL: 1,
      showTheRest: false,
      showTheRest_am: false,
      form: {
        postalCode: false
      }
      // checkboxListData: null,
    };
  },
  watch: {
    ["app.price"]: {
      deep: true,
      handler() {
        //this.checkboxListData = staticData.step2.checkboxListData(this);
      },
    },
    ["app.ins"]: {
      deep: true,
      handler() {
        // this.checkboxListData = staticData.step2.checkboxListData(this);
        this.forceUpdateCBL++;
        this.disableBtn = true;

        setTimeout(() => {
          this.disableBtn = false;
        }, 250);
      },
    },
  },
  methods: {
    carAgeChange(e) {
      this.dirty = true;

      this.$store.dispatch("app/carAgeChange", e);
    },
    AgeAndVehicleValueChange(item) {
      this.dirty = true;
      
      if (typeof item === 'object' && Object.prototype.hasOwnProperty.call(item, 'postalCode')) {
        this.form.postalCode = true;
      }

    },
    checkboxListChange(e) {
      this.dirty = true;
      
      this.$store.dispatch("app/checkboxListChange", {
        key: e.target.value,
        value: e.target.checked,
      });
    },
    buttonClick() {
      const carAge =
        this.app.ins.includeRoadAssistance == true ? this.app.ins.carAge > 0 : true;
      const formPostalCodeCheck = this.app.isAM ? true : this.form.postalCode;

      if (
        carAge &&
        this.app.disableApp == false &&
        !this.disableBtn &&
        this.app.error == "" &&
        this.app.price != -1 &&
        this.app.ins.postalCode &&
        formPostalCodeCheck &&
        (this.app.userInfo.ageRange.value != "18-20"
          ? this.app.ins.selectlicenseFor3Years
          : true) &&
        this.app.ins.newCarPrice.selectedvalue &&
        this.app.userInfo.ageRange.value
      ) {
        this.validateShow = false;
        this.$router.push({ name: "Step3" });
      } else {
        this.validateShow = true;
      }
    },
  },
  mounted() {
    if (this.app.isAM) {
      this.showTheRest = true;
      this.$store.dispatch("app/postalCode", 2860);
    }
    this.$store.dispatch("app/loading", false);
    this.$store.dispatch("app/setPreValuesAndGetPrice", false);

    // this.checkboxListData = staticData.step2.checkboxListData(this);
  },
  computed: {
    ...mapGetters(["app", "ins"]),
    checklistData() {
      return staticData.step2.checklistData;
    },
    checkboxListData() {
      return staticData.step2.checkboxListData(this);
    },
    ownRisk() {
      return staticData.step2.ownRisk(this);
    },
  },
});
</script>
<style lang="scss">
@import "@/assets/scss/essentials/essentials.scss";
@import "@/assets/scss/components/step.scss";

$itemHeight: 2.2rem;
$lineHeight: 1.6rem;
$padding: ($itemHeight - $lineHeight) / 2;

@import "../components/checkbox-list/info-hover.scss";
.price_container {
  padding-top: 1.25rem;
  .dirty-price {
    width: 100%;
    text-align: center;
    font-size: 1.2rem;
    line-height: normal;
    padding: 0;
    margin: 0;
  }
  .c-price__output {
    padding-left: 17px;
  }
}
.own-risk {
  text-align: center;
  display: block;
  width: 100%;
}
.showTheRest_container {
  width: 100%;
}
.showTheRest_button {
  &--am {
    button span::after {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 15px 10px 0 10px;
      border-color: #fff transparent transparent transparent;
      content: "";
      transform: translateY(2px);
      display: inline-block;
      margin-left: 10px;
    }
    &-active {
      button span::after {
        border-width: 0 10px 17px 10px;
        border-color: transparent transparent #fff transparent;
      }
    }
  }

  .c-button {
    max-width: 100%;
  }
}

.c-step--one .c-title.top-head {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.showTheRest-enter,
.showTheRest-leave-to {
  opacity: 0;
  //transform: translateX(-120px);
}
.showTheRest-enter-active,
.showTheRest-leave-active {
  transition: all 0.3s ease-in-out;
}

.select-license {
  .c-checkbox__visual {
    width: 1rem;
    height: 1rem;
    margin-top: 0.5rem;
  }
}

.carAgeslot {
  position: relative;

  .carAgeInputText {
    width: calc(100% - 42px);
    padding-left: 0px;
    margin-top: 16px;
  }

  .carAgeInfohover {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    width: 100%;
    & > button {
      position: absolute;
      right: 0;
      width: 42px;
    }
  }
  .carAgeInputText {
    // position: absolute;
    // top: 0;
    // right: 0;
    // z-index: 1;
  }
}
</style>
